const queries = {
	isEmpty: editor =>
		editor.value.document.text === '' &&
		editor.value.document.nodes.size === 1,
}

export default queries
